import { computed } from "vue";
import store from "@/store";

export default function useConceptItems() {
  const genres = computed(() => {
    // @ts-ignore
    return store.state.conceptItems.genres;
  });

  const ressorts = computed(() => {
    // @ts-ignore
    return store.state.conceptItems.genres;
  });

  return {
    genres,
    ressorts
  };
}
